import React from 'react';
import * as css from '../AIMessageGenerator.css';
import GeneratorChatMessage from '../generatorChatMessage/GeneratorChatMessage';
import GeneratorTypingIndicator from '../generatorTypingIndicator/GeneratorTypingIndicator';
import type {
    AIMessageGeneratorUserMessageProps,
    AssistantDraftPayload,
    ChatMessage,
} from '../utils/types';

interface GeneratorChatListProps {
    messages: ChatMessage[];
    draftLoading: boolean;
    approveLabel?: string;
    approveLoading: boolean;
    onApprove?: (draft: AssistantDraftPayload) => void;
    onEditMessage?: (index: number, newText: string) => void;
    renderUserMessage?: (props: AIMessageGeneratorUserMessageProps) => React.ReactNode;
}

function GeneratorChatList({
    messages,
    draftLoading,
    approveLabel,
    approveLoading,
    onApprove,
    onEditMessage,
    renderUserMessage,
}: GeneratorChatListProps) {
    return (
        <css.chatColumn>
            {messages.map((message, index) => (
                message.role === 'user' && renderUserMessage ? (
                    <React.Fragment key={message.id ?? index}>
                        {renderUserMessage({message, index, onEditMessage, draftLoading})}
                    </React.Fragment>
                ) : (
                    <GeneratorChatMessage
                        key={message.id ?? index}
                        message={message}
                        index={index}
                        messages={messages}
                        draftLoading={draftLoading}
                        approveLabel={approveLabel}
                        approveLoading={approveLoading}
                        onApprove={onApprove}
                    />
                )
            ))}
            {draftLoading && <GeneratorTypingIndicator />}
        </css.chatColumn>
    );
}

export default GeneratorChatList;
